let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4;
import styled from 'styled-components';
import { rotate } from '@ovpn-ui/styles';
import { ChevronDown } from '@ovpn-ui/icons';
import { Popper, Avatar } from '@ovpn-ui/core';
import { LayerIndex } from '../../constants';
import { sidebarWidth } from '../Sidebar.constants';
const rotateAnimation = rotate(0, 180);
export const Container = styled.div(_t || (_t = _`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    width: 100%;

    overflow: hidden;

    white-space: nowrap;

    cursor: pointer;

    &:focus {
        box-shadow: 0px 0px 0px 4px rgba(59, 145, 241, 0.45);
    }
`));
export const DropdownIcon = styled(ChevronDown)(_t2 || (_t2 = _`
    color: ${0};

    && {
        ${0}
    }
`), t => t.theme.text, rotateAnimation);
export const StyledPopper = styled(Popper)(_t3 || (_t3 = _`
    z-index: ${0};

    width: ${0};

    margin: ${0};

    border-radius: 4px;
    box-shadow: 0 8px 22px -6px rgba(9, 41, 116, 0.12), 0px 14px 64px -4px rgba(28, 86, 178, 0.12);
`), LayerIndex.Modal, props => props.mobile ? '94%' : `${sidebarWidth}px`, props => props.mobile ? '0 0 0 5px' : `-14px`);
export const StyledAvatar = styled(Avatar)(_t4 || (_t4 = _`
    max-width: 234px;

    & > .ovpn-avatar-figure {
        margin: 0;

        color: ${0};

        background-color: ${0};

        &:hover {
            background-color: ${0};
        }

        &:focus {
            background-color: ${0};
            box-shadow: unset;
        }
    }

    .ovpn-avatar-label {
        overflow: hidden;

        .ovpn-avatar-title {
            max-width: 100%;

            overflow: hidden;

            white-space: nowrap;

            text-overflow: ellipsis;
        }
    }
`), t => t.theme.bg, t => t.theme.text, t => t.theme.text, t => t.theme.text);